/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Collected_By_DriverInputs */

const vi_order_collected_by_driver = /** @type {(inputs: Order_Collected_By_DriverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tài xế thu`)
};

/**

* @param {Order_Collected_By_DriverInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_collected_by_driver = /** @type {((inputs?: Order_Collected_By_DriverInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Collected_By_DriverInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_collected_by_driver(inputs)
});